import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import ApiKey from 'modules/api_public/store/models/ApiKey'

export class ApiKeys extends Collection<ApiKey> {
  get cacheKey(): string {
    return 'apiKeys'
  }

  model() {
    return ApiKey
  }
}

const { provider: ApiKeyProvider, hook: useApiKeys } = createCollectionContext<ApiKey, ApiKeys>()

export { ApiKeyProvider, useApiKeys }
